'use client';

import EarthIcon from '@/assets/icons/Earth';
import {useLanguageSwitcher} from '@/components/LanguageSwitcher/hooks';
import {Button} from '@/components/ui/button';
import {Command, CommandEmpty, CommandInput, CommandItem, CommandList} from '@/components/ui/command';
import {Popover, PopoverContent, PopoverTrigger} from '@/components/ui/popover';
import {cn} from '@/lib/utils';
import {CheckIcon} from '@radix-ui/react-icons';
import {useState} from 'react';

export default function LanguageSwitcher({languages = [], labels = {}, className}) {
    const {locale, getLink} = useLanguageSwitcher();
    const [open, setOpen] = useState(false);

    const {switch_language} = labels;

    if (languages.length < 2) return <></>;

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    id='select-43'
                    variant='outline'
                    role='combobox'
                    aria-expanded={open}
                    className={cn(
                        'w-full justify-between bg-background px-3 font-normal outline-offset-0 hover:bg-background focus-visible:border-ring focus-visible:outline-[3px] focus-visible:outline-ring/20 border-none p-0',
                        className
                    )}
                >
                    <EarthIcon/>
                </Button>
            </PopoverTrigger>
            <PopoverContent
                className='w-full min-w-[var(--radix-popper-anchor-width)] border-input p-0'
                align='start'
                hideWhenDetached
            >
                <Command
                    filter={(value, search) => {
                        const normalizedValue = value.toLowerCase();
                        const normalizedSearch = search.toLowerCase().replace(/\s+/g, '');
                        return normalizedValue.includes(normalizedSearch) ? 1 : 0;
                    }}
                >
                    <CommandInput placeholder={switch_language}/>
                    <CommandList className='max-h-96'>
                        <CommandEmpty/>
                        {languages.map(language => (
                            <a href={getLink(language.code)} key={language.id}>
                                <CommandItem

                                    value={language.code}
                                    className='text-background font-medium'
                                >

                                    {language.label}
                                    {language.code === locale &&
                                        <CheckIcon size={16} strokeWidth={2} className='ml-auto'/>}
                                </CommandItem></a>
                        ))}
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
